const t = "_text_1h51g_1", e = {
  text: t
};
export {
  e as default,
  t as text
};
